export default __webpack_public_path__ + "static/media/img5.5c9493d2.jpg";